import React, { useEffect, useState } from "react";
import heroLogo from "../../../utils/assets/img/Logo.png";

export default function PublicCatalogHero({ seller }) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth < 640);
        }

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    if (isMobile) {
        return (
            <div style={{ ...styles.hero, ...styles.heroMobile }}>
                <div style={styles.mobileTop}>
                    <div style={styles.mobileLeft}>
                        <div style={{ ...styles.kicker, ...styles.kickerMobile }}>
                            Catálogo exclusivo
                        </div>

                        <div style={{ ...styles.title, ...styles.titleMobile }}>
                            Joias personalizadas
                        </div>
                    </div>

                    <div style={styles.mobileRight}>
                        <img
                            src={heroLogo}
                            alt="Logo"
                            style={{ ...styles.logo, ...styles.logoMobile }}
                        />
                    </div>
                </div>

                <div style={styles.mobileFooter}>
                    Você está comprando com <b>{seller?.display_name || "Revendedora"}</b>.
                </div>
            </div>
        );
    }

    return (
        <div style={styles.hero}>
            <div style={styles.content}>
                <div style={styles.left}>
                    <div style={styles.kicker}>
                        Catálogo exclusivo
                    </div>

                    <div style={styles.title}>
                        Joias personalizadas
                    </div>

                    <div style={styles.sub}>
                        Você está comprando com <b>{seller?.display_name || "Revendedora"}</b>.
                    </div>
                </div>

                <div style={styles.right}>
                    <img
                        src={heroLogo}
                        alt="Logo"
                        style={styles.logo}
                    />
                </div>
            </div>
        </div>
    );
}

const styles = {
    hero: {
        width: "100%",
        padding: "26px 22px",
        background: "linear-gradient(135deg, #902348 0%, #b53d67 100%)",
        color: "#fff",
        boxShadow: "0 10px 26px rgba(144,35,72,0.18)",
        boxSizing: "border-box",
        overflow: "hidden",
        borderRadius: "8px",
    },

    heroMobile: {
        padding: "14px 14px 12px",
        borderRadius: "8px",
    },

    content: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
    },

    left: {
        flex: 1,
        minWidth: 0,
    },

    right: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
    },

    mobileTop: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
    },

    mobileLeft: {
        flex: 1,
        minWidth: 0,
    },

    mobileRight: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        flexShrink: 0,
    },

    mobileFooter: {
        marginTop: 10,
        padding: "10px 12px",
        borderRadius: 10,
        background: "linear-gradient(135deg, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0.08) 100%)",
        border: "1px solid rgba(255,255,255,0.14)",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.35,
        opacity: 0.98,
        width: "100%",
        boxSizing: "border-box",
    },

    logo: {
        width: 180,
        height: "auto",
        objectFit: "contain",
        opacity: 0.95,
    },

    logoMobile: {
        width: 92,
        opacity: 0.92,
    },

    kicker: {
        fontSize: 12,
        fontWeight: 800,
        textTransform: "uppercase",
        letterSpacing: 1.2,
        opacity: 0.85,
    },

    kickerMobile: {
        fontSize: 9,
        letterSpacing: 0.9,
    },

    title: {
        marginTop: 6,
        fontSize: 30,
        fontWeight: 900,
        lineHeight: 1.1,
    },

    titleMobile: {
        marginTop: 4,
        fontSize: 18,
        lineHeight: 1.05,
    },

    sub: {
        marginTop: 10,
        fontSize: 15,
        fontWeight: 500,
        opacity: 0.95,
    },
};